import type { LoaderFunctionArgs, MetaFunction } from 'react-router';
import { generateMeta } from '~/services/meta';
import AiToolAllListing from '~/components/AiToolAllListing';
import { prompts } from '~/services';
import { useLoaderData } from 'react-router';

const title = 'Tools: Everything You Need, All in One Place';
const description =
    'Explore our suite of over 60 Free AI tools tailored to meet all your needs. 100% FREE, No Login. Enhance productivity, creativity, and efficiency in one place. Elevate your digital experience with the power of AI.';

export const meta: MetaFunction = () => {
    return generateMeta({
        title: `60+ Free AI ${title}`,
        description: description,
    });
};

export async function loader({ params }: LoaderFunctionArgs) {
    return Response.json({ prompts: prompts });
}

export default function Index() {
    const { prompts } = useLoaderData();
    return (
        <AiToolAllListing
            title={title}
            description={description}
            prompts={prompts.filter((p) => p.id !== 'ocr-text')}
        />
    );
}
